/* Defy Sports 2026 — Hero Slider */
(function () {
  'use strict';

  function initHero(hero) {
    const slides    = hero.querySelectorAll('.defy-hero__slide');
    const texts     = hero.querySelectorAll('.defy-hero__text');
    const dots      = hero.querySelectorAll('.defy-hero__dot');
    const bar       = hero.querySelector('.defy-hero__progress-bar');
    const autoplay  = hero.dataset.autoplay !== 'false';
    const interval  = parseInt(hero.dataset.interval, 10) || 5000;

    if (slides.length < 2) return;

    let current = 0;
    let timer   = null;
    let paused  = false;

    function applyAccent(index) {
      const accent = slides[index] && slides[index].dataset.accent;
      if (accent) hero.style.setProperty('--slide-accent', accent);
    }

    function goTo(index) {
      const prev = current;
      current = (index + slides.length) % slides.length;

      slides[prev].classList.remove('is-active');
      slides[current].classList.add('is-active');

      if (texts[prev]) texts[prev].classList.remove('is-active');
      if (texts[current]) texts[current].classList.add('is-active');

      dots.forEach((d, i) => {
        d.classList.toggle('is-active', i === current);
        d.setAttribute('aria-selected', i === current ? 'true' : 'false');
      });

      applyAccent(current);
      resetProgress();
    }

    function next() { goTo(current + 1); }

    function resetProgress() {
      if (!bar) return;
      bar.style.transition = 'none';
      bar.style.width = '0%';
      requestAnimationFrame(() => {
        requestAnimationFrame(() => {
          bar.style.transition = `width ${interval}ms linear`;
          bar.style.width = '100%';
        });
      });
    }

    function startTimer() {
      if (!autoplay) return;
      clearInterval(timer);
      timer = setInterval(next, interval);
      resetProgress();
    }

    function stopTimer() {
      clearInterval(timer);
      if (bar) { bar.style.transition = 'none'; }
    }

    // Dot click
    dots.forEach((dot, i) => {
      dot.addEventListener('click', () => {
        goTo(i);
        stopTimer();
        startTimer();
      });
    });

    // Pause on hover
    hero.addEventListener('mouseenter', () => { paused = true; stopTimer(); });
    hero.addEventListener('mouseleave', () => { paused = false; startTimer(); });

    // Touch swipe
    let touchStartX = 0;
    hero.addEventListener('touchstart', (e) => { touchStartX = e.touches[0].clientX; }, { passive: true });
    hero.addEventListener('touchend', (e) => {
      const diff = touchStartX - e.changedTouches[0].clientX;
      if (Math.abs(diff) > 50) {
        goTo(diff > 0 ? current + 1 : current - 1);
        stopTimer();
        startTimer();
      }
    }, { passive: true });

    applyAccent(0); // set initial accent on load
    startTimer();
  }

  document.querySelectorAll('.defy-hero').forEach(initHero);
})();

// ── Smooth scroll for "Shop Teamwear" CTA when no URL is set ──────────────
document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('.defy-hero__scroll-cta').forEach(function (btn) {
    btn.addEventListener('click', function (e) {
      e.preventDefault();
      var target = document.querySelector('[data-anchor-id="sports-grid"]');
      if (target) {
        target.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    });
  });
});
